import { aboveTypes } from '../types'

export const pages: aboveTypes[] = ['Provably Fair', 'Game Rules', 'History']
